export enum HealthIndicatorValueEnum {
    OK = 'OK',
    NA = 'NA',
    KO = 'KO',
    WARNING = 'WARNING'
};